import { PersonInfo, Pronoun, ROLE } from '../../consts';
import image from './courtni-wong.jpg';

export const CourtniWong: PersonInfo = {
  firstName: 'Courtni',
  lastName: 'Wong',
  image,
  pronoun: Pronoun.SHE,
  role: ROLE.SOFTWARE_ENGINEER,
};
